// @ts-nocheck
// ====== Ricerca globale: una sola ricerca ======
// La casella in alto (#globalSearch) NON è un secondo motore di ricerca: è il
// "pulsante" che apre l'unica ricerca del portale, la palette ⌘K (clienti,
// risorse, persone, sezioni e azioni rapide). Così c'è un solo modo di cercare,
// uguale ovunque. La ricerca testuale DENTRO l'elenco clienti vive nella vista
// Clienti (#clientiSearch).

function wireSearchLauncher() {
  const input = document.getElementById('globalSearch');
  if (!input || input.dataset.gsWired === '1') return;
  input.dataset.gsWired = '1';
  // La casella diventa un avvio-ricerca: non si scrive qui, si apre la palette.
  input.readOnly = true;
  input.setAttribute('role', 'button');
  input.setAttribute('aria-label', 'Apri la ricerca (clienti, risorse, persone, sezioni)');
  const open = () => {
    if (typeof openQuickSwitcher === 'function') openQuickSwitcher();
    // togli il focus dalla casella così la palette prende il comando e non si riapre
    setTimeout(() => input.blur(), 0);
  };
  input.addEventListener('focus', open);
  input.addEventListener('click', open);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wireSearchLauncher);
} else {
  wireSearchLauncher();
}

Object.assign(globalThis, { wireSearchLauncher });
export {};
